'use client';

import {Modal, type ModalProps} from '@udemy-v2/react-dialog-components';
import {useI18n} from '@udemy-v2/i18n';
import {Button} from '@udemy-v2/react-core-components';
import {ExpressiveIcon, type ExpressiveIconName} from '@udemy-v2/icons-expressive';
import styles from './lifetime-access-modal.module.scss';

export interface LifetimeAccessModalProps {
    isOpen: ModalProps['isOpen'];
    onClose: NonNullable<ModalProps['onClose']>;
}

export const LifetimeAccessModal = ({isOpen, onClose}: LifetimeAccessModalProps) => {
    const {gettext} = useI18n();

    const items: {name: ExpressiveIconName; text: string}[] = [
        {
            name: 'new',
            text: gettext(
                'Maintain access to this course even if you no longer subscribe to Personal Plan content',
            ),
        },
        {
            name: 'learning-delivery',
            text: gettext(
                'Continue to have access to this course after you complete it — review specific content in the course or take it all over again',
            ),
        },
    ];

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={gettext("What's included with Lifetime Access")}
            data-purpose="lifetime-access-modal"
        >
            <ul className={styles['list']} data-purpose="lifetime-access-modal-list">
                {items.map((item) => (
                    <li key={item.name} className={styles['item']}>
                        <ExpressiveIcon
                            className={styles['icon']}
                            name={item.name}
                            colorScheme="light"
                            size="medium"
                        />
                        <span className={styles['text']}>{item.text}</span>
                    </li>
                ))}
            </ul>
            <div className={styles['footer']}>
                <Button
                    udStyle="primary"
                    onClick={onClose}
                    data-purpose="lifetime-access-modal-close"
                >
                    {gettext('Close')}
                </Button>
            </div>
        </Modal>
    );
};
